import { decimalIn } from 'Helpers/currencyFormat';

export { formatRate } from '../ShowInSelect';

const CHECK_AMOUNT = 1000000;

/**
 * Whether typed text is a usable rate: above zero, to at most six decimal
 * places. The text itself is what is sent, never a parsed number, so a rate
 * such as 0.000049 reaches the server exactly as typed.
 */
export function isRate(text) {
    const value = String(text ?? '').trim();

    return /^(\d+(\.\d{1,6})?|\.\d{1,6})$/.test(value) && Number(value) > 0;
}

/**
 * The check beside every rate: what 1,000,000 of the currency is in the
 * anchor at this rate. A reciprocal typed by mistake shows up here.
 */
export function checkFigure(currency, anchor, rate) {
    if (!isRate(rate)) {
        return null;
    }

    return {
        from: `${currency} ${decimalIn(null, CHECK_AMOUNT, 0)}`,
        to: `${anchor} ${decimalIn(null, Math.round(CHECK_AMOUNT / Number(rate)), 0)}`,
    };
}

/**
 * The notes the server writes itself arrive as a key and its parameters, and
 * are worded here so they read in the viewer's language.
 */
export function noteText(key, params = {}) {
    const values = { project: '—', currency: '—', anchor: '—', old: '—', new: '—', ...(params || {}) };

    switch (key) {
        case 'auto_created':
            return $t('Added when {{project}} was created', values);
        case 'auto_set':
            return $t('Added when {{project}} was set to {{currency}}', values);
        case 'auto_added':
            return $t('Added for {{project}}', values);
        case 'rebased':
            return $t('Rebased from {{anchor}} anchor', values);
        case 'lock_cleared':
            return $t('Lock cleared: currency changed from {{old}} to {{new}}', values);
        case 'new_anchor':
            return $t('The project is in the new anchor currency');
        case 'reason':
            return values.reason || null;
        default:
            return null;
    }
}
